export default "__VITE_ASSET__CALvmrC8__"